var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe3209(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 372.608,
    viewBox: "0 0 500 372.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3209",
    "data-name": "Groupe 3209",
    transform: "translate(-787.5 -2066.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(787.5 2012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 500,
    height: 0.25,
    transform: "translate(0 382.398)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 18.888,
    height: 0.25,
    transform: "translate(416.779 398.494)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 29.473,
    height: 0.25,
    transform: "translate(293.054 396.75)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 47.111,
    height: 0.25,
    transform: "translate(368.667 389.208)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 10.971,
    height: 0.25,
    transform: "translate(52.459 390.888)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 38.555,
    height: 0.25,
    transform: "translate(72.333 390.888)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 54.147,
    height: 0.25,
    transform: "translate(171 395.111)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M237.014,337.8H43.915a5.715,5.715,0,0,1-5.708-5.708V60.66a5.714,5.714,0,0,1,5.708-5.707h193.1a5.714,5.714,0,0,1,5.707,5.707V332.092A5.715,5.715,0,0,1,237.014,337.8ZM43.915,55.2a5.463,5.463,0,0,0-5.458,5.457V332.092a5.464,5.464,0,0,0,5.458,5.458h193.1a5.463,5.463,0,0,0,5.457-5.458V60.66a5.463,5.463,0,0,0-5.457-5.457Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M453.31,337.8h-193.1a5.714,5.714,0,0,1-5.707-5.708V60.66a5.713,5.713,0,0,1,5.707-5.707h193.1a5.714,5.714,0,0,1,5.709,5.707V332.092A5.715,5.715,0,0,1,453.31,337.8ZM260.212,55.2a5.463,5.463,0,0,0-5.457,5.457V332.092a5.463,5.463,0,0,0,5.457,5.458h193.1a5.464,5.464,0,0,0,5.459-5.458V60.66A5.464,5.464,0,0,0,453.31,55.2Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 74.594,
    height: 186.397,
    transform: "translate(137.385 266.642) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 83.478,
    height: 186.397,
    transform: "translate(135.472 266.642) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 169.178,
    height: 66.258,
    transform: "translate(126.862 88.854) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 74.594,
    height: 186.397,
    transform: "translate(228.934 266.642) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 83.478,
    height: 186.397,
    transform: "translate(227.02 266.642) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 169.178,
    height: 66.258,
    transform: "translate(218.41 88.854) rotate(90)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 61.136,
    height: 73.257,
    transform: "translate(218.944 309.142)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M280.08,309.142H218.944l-13.763-14.009h61.135Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M183.16,295.133H122.025l-11.544,14.009h61.135Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 108.464,
    height: 73.257,
    transform: "translate(218.944 382.398) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 7.859,
    height: 34.125,
    transform: "translate(218.944 362.833) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 29.69,
    height: 29.69,
    transform: "translate(147.365 351.417) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 29.69,
    height: 29.69,
    transform: "translate(110.607 351.417) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 2.417,
    height: 29.69,
    transform: "translate(147.365 355.668) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 2.417,
    height: 29.69,
    transform: "translate(110.607 355.668) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 2.417,
    height: 29.69,
    transform: "translate(147.366 362.755) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 2.417,
    height: 29.69,
    transform: "translate(110.608 362.755) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 2.417,
    height: 29.69,
    transform: "translate(147.365 369.842) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 2.417,
    height: 29.69,
    transform: "translate(110.607 369.842) rotate(-90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 17.61,
    height: 34.125,
    transform: "translate(218.944 328.707)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 29.363,
    height: 164.733,
    transform: "translate(332.585 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M311.063,382.4h-7.841V353.927h16.062Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 29.363,
    height: 164.733,
    transform: "translate(416.778 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 91.036,
    height: 154.933,
    transform: "translate(394.258 372.599) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M386.418,382.4h7.841V353.927H378.2Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 78.871,
    height: 67.655,
    transform: "translate(388.175 366.167) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 53.839,
    height: 67.655,
    transform: "translate(388.175 366.167) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 78.871,
    height: 67.655,
    transform: "translate(388.175 292.5) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 53.839,
    height: 67.655,
    transform: "translate(388.175 292.5) rotate(180)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M361.256,276.617c0,8.736-7.427,15.884-16.5,15.884h-8.192c-9.077,0-16.5-7.148-16.5-15.884Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M361.256,265.506c0,8.736-7.427,15.884-16.5,15.884h-8.192c-9.077,0-16.5-7.148-16.5-15.884Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M353.027,320.333h24.281s-4.216,10.222-4.216,16.238,18.469,29.6-7.925,29.6-7.925-23.581-7.925-29.6S353.027,320.333,353.027,320.333Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M361.256,254.4c0,8.736-7.427,15.884-16.5,15.884h-8.192c-9.077,0-16.5-7.148-16.5-15.884Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M354.04,205.727c-.924-26.053-1.91-73.835.108-86.9l3.293-2.542s-.721,23.923-1.1,63.839-.849,19.674-.446,25.605Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M346.475,136.458c-7.634-5.507-23.708-9.424-40.349-9.4-6.534.008,19.456,6.407,29.977,13.468,8.173,5.485,17.188,14.713,20.124,19.835C354.816,149.581,354.109,141.966,346.475,136.458Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M361.789,150.811c7.015-5.736,22.63-10.147,39.245-10.645,6.523-.2-18.717,7-28.443,14.379-7.555,5.731-15.539,15.224-17.906,20.429C354.907,164.172,354.775,156.547,361.789,150.811Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M355.272,217.667h0a12.108,12.108,0,0,1-12.088-11.414l-1.07-8.8H368.43l-1.069,8.8A12.11,12.11,0,0,1,355.272,217.667Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M370.134,201.667H340.41l-.851-7.711h31.427Z",
    fill: "#f0f0f0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(787.5 2012)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: 193.889,
    cy: 11.323,
    rx: 193.889,
    ry: 11.323,
    transform: "translate(56.111 404.915)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Server",
    transform: "translate(787.5 2012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_41",
    "data-name": "Groupe 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_37",
    "data-name": "Groupe 37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 102.974,
    height: 193.864,
    transform: "translate(169.898 222.374)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 112.605,
    height: 2.369,
    transform: "translate(179.374 220.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 112.605,
    height: 2.369,
    transform: "translate(179.374 220.005)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_16",
    "data-name": "Groupe 16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 28.581,
    height: 193.864,
    transform: "translate(301.454 416.238) rotate(180)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 28.581,
    height: 193.864,
    transform: "translate(301.454 416.238) rotate(180)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(257.867 231.62)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(242.152 231.62)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(226.437 231.62)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(210.722 231.62)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(195.007 231.62)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 7.616,
    height: 7.659,
    rx: 0.928,
    transform: "translate(179.292 231.62)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 96.249,
    height: 30.351,
    transform: "translate(173.261 243.67)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(260.053 248.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(249.096 248.005)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(238.138 248.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(227.181 248.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M200.83,254.006a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,200.83,254.006Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M217.843,263.685a3.5,3.5,0,1,1-3.5-3.5A3.5,3.5,0,0,1,217.843,263.685Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M210.838,254.006a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,210.838,254.006Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M207.835,263.685a3.5,3.5,0,1,1-3.5-3.5A3.5,3.5,0,0,1,207.835,263.685Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.588,
    cy: 7.588,
    r: 7.588,
    transform: "translate(176.149 258.846) rotate(-45)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 96.249,
    height: 30.351,
    transform: "translate(173.261 278.184)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(260.053 282.519)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(249.096 282.519)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(238.138 282.519)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(227.181 282.519)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M200.83,288.519a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,200.83,288.519Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 294.697)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23",
    "data-name": "Groupe 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M210.838,288.519a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,210.838,288.519Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 294.697)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 7.588,
    cy: 7.588,
    r: 7.588,
    transform: "translate(179.292 285.772)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 96.249,
    height: 30.35,
    transform: "translate(173.261 312.698)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(260.053 317.033)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(249.096 317.033)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(238.138 317.033)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(227.181 317.033)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M200.83,323.033a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,200.83,323.033Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 329.21)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M210.838,323.033a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,210.838,323.033Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 329.21)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 7.588,
    cy: 7.588,
    r: 7.588,
    transform: "translate(179.292 320.285)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 96.249,
    height: 30.35,
    transform: "translate(173.261 347.211)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(260.053 351.546)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(249.096 351.546)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(238.138 351.546)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(227.181 351.546)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 354.044)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 363.724)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 354.044)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 363.724)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 7.588,
    cy: 7.588,
    r: 7.588,
    transform: "translate(179.292 354.799)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 96.249,
    height: 30.35,
    transform: "translate(173.261 381.724)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(260.053 386.06)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(249.096 386.06)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(238.138 386.06)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 5.31,
    height: 21.68,
    rx: 1.304,
    transform: "translate(227.181 386.06)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 388.557)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 398.237)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(210.838 388.557)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3.503,
    cy: 3.503,
    r: 3.503,
    transform: "translate(200.83 398.237)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 7.588,
    cy: 7.588,
    r: 7.588,
    transform: "translate(179.292 389.312)",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_39",
    "data-name": "Groupe 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M172.763,175.087h74.3l10.447,42.565h-74.3Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M204.21,217.652l.292,2.353h79.377l-.292-2.353Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_38",
    "data-name": "Groupe 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M244.845,175.087l10.447,42.565h0l.292,2.353H183.5l-.292-2.353-10.447-42.565Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M244.845,175.087l10.447,42.565h0l.292,2.353H183.5l-.292-2.353-10.447-42.565Z",
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_40",
    "data-name": "Groupe 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M214.9,149.914l-.465-.244c-.6-.313-14.633-7.78-16.616-17.592a86.274,86.274,0,0,1-1.464-19.065l.044-.881.879-.066c.1-.008,10.568-.823,17.318-2.975l.3-.1.3.1c6.753,2.153,17.213,2.967,17.319,2.975l.879.066.044.881a86.377,86.377,0,0,1-1.465,19.065c-1.984,9.812-16.019,17.279-16.616,17.592Zm-16.576-35.93a85.967,85.967,0,0,0,1.455,17.7c1.606,7.943,12.7,14.6,15.121,15.962,2.42-1.367,13.513-8.019,15.119-15.962a85.916,85.916,0,0,0,1.456-17.7,92.787,92.787,0,0,1-16.575-2.892A92.84,92.84,0,0,1,198.32,113.984Z",
    fill: "#407bff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M214.9,144.353c-4.186-2.56-11.243-7.864-12.329-13.236a80.27,80.27,0,0,1-1.415-14.561,91.3,91.3,0,0,0,13.744-2.494,91.418,91.418,0,0,0,13.743,2.494,80.581,80.581,0,0,1-1.413,14.561C226.139,136.489,219.082,141.793,214.9,144.353Z",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M143.911,416.238h-2V182.555a21.724,21.724,0,0,1,21.7-21.7h44.6a5.7,5.7,0,0,0,5.69-5.689h2a7.7,7.7,0,0,1-7.69,7.689h-44.6a19.721,19.721,0,0,0-19.7,19.7Z",
    fill: "#407bff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3208",
    "data-name": "Groupe 3208",
    transform: "translate(114.924 1869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3256",
    "data-name": "Trac\\xE9 3256",
    d: "M190.966,172.7l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04L185.1,176.97l4.056-.59Z",
    transform: "translate(703.061 291.261)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3207",
    "data-name": "Groupe 3207",
    transform: "translate(854.007 394.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3248",
    "data-name": "Trac\\xE9 3248",
    d: "M132.761,70.238l1.814,3.676,4.056.59L135.7,77.364l.693,4.04L132.761,79.5,129.134,81.4l.693-4.04L126.891,74.5l4.056-.59Z",
    transform: "translate(-122.248 -52.446)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3249",
    "data-name": "Trac\\xE9 3249",
    d: "M157.963,45.036l1.814,3.676,4.056.59L160.9,52.162l.693,4.04-3.628-1.908L154.335,56.2l.693-4.04L152.093,49.3l4.056-.59Z",
    transform: "translate(-134.674 -40.021)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3250",
    "data-name": "Trac\\xE9 3250",
    d: "M191.644,35.144l1.814,3.676,4.056.59-2.935,2.861.693,4.04L191.644,44.4l-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-151.28 -35.144)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3251",
    "data-name": "Trac\\xE9 3251",
    d: "M226.5,45.272l1.814,3.676,4.056.59L229.438,52.4l.693,4.04L226.5,54.53l-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-168.466 -40.137)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3252",
    "data-name": "Trac\\xE9 3252",
    d: "M250.527,69.3l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908L246.9,80.462l.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-180.311 -51.981)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3253",
    "data-name": "Trac\\xE9 3253",
    d: "M259.241,104.154l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-184.607 -69.168)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3254",
    "data-name": "Trac\\xE9 3254",
    d: "M250.762,138.777l1.814,3.676,4.056.59L253.7,145.9l.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-180.427 -86.238)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3255",
    "data-name": "Trac\\xE9 3255",
    d: "M225.248,162.8l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-167.846 -98.083)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3257",
    "data-name": "Trac\\xE9 3257",
    d: "M158.228,162.813l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-134.805 -98.088)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3258",
    "data-name": "Trac\\xE9 3258",
    d: "M132.319,138.151l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-122.031 -85.929)",
    fill: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3259",
    "data-name": "Trac\\xE9 3259",
    d: "M123.6,104.194l1.814,3.676,4.056.59-2.935,2.861.693,4.04-3.628-1.908-3.628,1.908.693-4.04-2.935-2.861,4.056-.59Z",
    transform: "translate(-117.734 -69.187)",
    fill: "#fff500"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe3209);
export default __webpack_public_path__ + "static/media/Groupe-3209.e030730d893e3a3d8608dd8e0fa47c97.svg";
export { ForwardRef as ReactComponent };